import { useFetchMixAPi1, useMixApi1Toast } from "hooks";
import { getURLWithParams } from "utils/context";

const enc = sigla => encodeURIComponent(sigla);

export const useModificadoresListagem = (params = {}) =>
  useFetchMixAPi1(getURLWithParams("/modificadores/search", params));

export const useModificadorDetail = sigla =>
  useFetchMixAPi1(sigla ? `/modificadores/detalhes/${enc(sigla)}` : null);

export const useModificadorRegras = sigla =>
  useFetchMixAPi1(sigla ? `/modificadores/regras/${enc(sigla)}` : null);

export const useModificadorClientes = (sigla, params = {}) =>
  useFetchMixAPi1(
    sigla
      ? getURLWithParams(`/modificadores/clientes/${enc(sigla)}`, params)
      : null,
  );

export const useModificadores = (sigla = null) => {
  const { onSend, isLoading } = useMixApi1Toast();

  const onSave = data =>
    onSend({
      endpoint: sigla ? `modificadores/update/${enc(sigla)}` : "modificadores",
      type: sigla ? "PUT" : "POST",
      data,
      messageSuccess: sigla
        ? "Modificador editado com sucesso"
        : "Modificador cadastrado com sucesso",
      messageFail: sigla
        ? "Não foi possível editar o Modificador"
        : "Não foi possível cadastrar o Modificador",
      redirect: !sigla,
      fieldGetId: "mod_sigla",
      urlRedirect: "/legislacao/modificadores/detail",
    });

  const onDelete = () =>
    onSend({
      endpoint: `modificadores/destroy/${enc(sigla)}`,
      type: "DELETE",
      messageSuccess: "Modificador excluído com sucesso",
      messageFail: "Não foi possível excluir o Modificador",
    });

  const onVincularRegra = regId =>
    onSend({
      endpoint: `modificadores/regras/${enc(sigla)}`,
      type: "POST",
      data: { mxf_reg_id: regId },
      messageSuccess: "Regra vinculada com sucesso",
      messageFail: "Não foi possível vincular a Regra",
    });

  const onDesvincularRegra = regId =>
    onSend({
      endpoint: `legislacao/regras-tributacao/modificador/delete`,
      type: "POST",
      data: { mxf_reg_id: regId, mod_sigla: sigla },
      messageSuccess: "Regra desvinculada com sucesso",
      messageFail: "Não foi possível desvincular a Regra",
    });

  return { onSave, onDelete, onVincularRegra, onDesvincularRegra, isLoading };
};
